/* Live search: native input, debounce, suggest.json. No morph / no scroll-lock. */
(function () {
  var CSS = '.ddu-live-box{position:absolute;left:0;right:0;top:100%;z-index:30;background:#fffdf9;border:1px solid #e7dfd1;border-radius:10px;margin-top:6px;max-height:70vh;overflow:auto;box-shadow:0 12px 32px rgba(20,23,13,.12)}.ddu-live-item{display:flex;gap:10px;align-items:center;padding:10px 12px;text-decoration:none;color:#20241d;border-bottom:1px solid #f0e8d8}.ddu-live-item img{width:44px;height:44px;object-fit:cover;border-radius:6px;background:#efe7d8;flex:none}.ddu-live-item b{display:block;font:600 14px/1.25 "Cormorant Garamond",serif}.ddu-live-item small{color:#6b6e62;font-size:11px}.ddu-live-all{display:block;text-align:center;padding:12px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#2c4131;text-decoration:none}.ddu-live-empty{padding:14px;color:#6b6e62;font-size:13px}';
  function ensureCss() {
    if (document.getElementById('ddu-live-search-css')) return;
    var s = document.createElement('style');
    s.id = 'ddu-live-search-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function bind(input) {
    if (!input || input.dataset.dduLiveBound) return;
    input.dataset.dduLiveBound = '1';
    ensureCss();
    var wrap = input.parentElement;
    if (wrap && getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    var box = wrap.querySelector('.ddu-live-box');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ddu-live-box';
      box.hidden = true;
      wrap.appendChild(box);
    }
    var t = null, ac = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (t) clearTimeout(t);
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      t = setTimeout(function () { go(q); }, 260);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { box.hidden = true; }
    });
    function go(q) {
      if (ac) ac.abort();
      ac = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';
      fetch(url, { signal: ac.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            box.hidden = false;
            box.innerHTML = '<div class="ddu-live-empty">Sin resultados</div>';
            return;
          }
          box.hidden = false;
          box.innerHTML = products.map(function (p) {
            var img = p.image || '';
            var price = p.price || '';
            return '<a class="ddu-live-item" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44">' : '') +
              '<span><b>' + esc(p.title) + '</b><small>' + esc(String(price)) + '</small></span></a>';
          }).join('') +
            '<a class="ddu-live-all" href="/search?q=' + encodeURIComponent(q) + '">Ver todos</a>';
        })
        .catch(function () { /* keep typing */ });
    }
  }
  function scan() {
    document.querySelectorAll('input[name="q"], .search-input, #Search-In-Modal, input[type="search"]').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  setTimeout(scan, 600);
})();
